/**
 * This is the starting point of your application.
 * Feature Hub Apps will use this file to bootstrap the app.
 */
import { ThemeProvider } from '@oneaudi/unified-web-common';
import React from 'react';
import { ContentLink } from './components/contentLink';
import { getThemeName } from '../alpha-helper';
import styled from 'styled-components';

const Layout = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
`;

const FeatureApp = () => {
  return (
    <ThemeProvider theme={{ name: getThemeName() }}>
      <Layout>
        <ContentLink />
      </Layout>
    </ThemeProvider>
  );
};

export default FeatureApp;
